document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('.tabs li');
  const contents = document.querySelectorAll('.tabs-content li');
  const activeTab = document.querySelector('.active-tab');

  // Helper to get the index of an element relative to its siblings
  const getIndex = (el) => [...el.parentElement.children].indexOf(el);

  // 1. Initial State: Show content of active tab on load
  if (activeTab) {
    const initialIndex = getIndex(activeTab);
    // Hide all contents first, then show the active one
    contents.forEach(li => li.style.display = 'none');
    if (contents[initialIndex]) {
      contents[initialIndex].style.display = 'block';
    }
  }

  // 2. Click Event Delegation
  const tabsContainer = document.querySelector('.tabs');
  if (tabsContainer) {
    tabsContainer.addEventListener('click', (e) => {
      const current = e.target.closest('li');
      
      // Ensure the click was actually on a list item
      if (!current || !tabsContainer.contains(current)) return;

      const index = getIndex(current);

      // Remove 'active-tab' class from all tabs and add to current
      tabs.forEach(tab => tab.classList.remove('active-tab'));
      current.classList.add('active-tab');

      // Hide all content items and show the one matching the index
      contents.forEach((content, i) => {
        content.style.display = (i === index) ? 'block' : 'none';
      });
    });
  }
});







document.addEventListener('DOMContentLoaded', function() {
  const container = document.querySelector('.tabs-container');
  const toggle = document.querySelector('.tabs-mobile-toggle');
  const tabs = document.querySelectorAll('.tabs li');
  const contents = document.querySelectorAll('.tabs-content li');

  // Helper to get index (ignoring non-LI elements like the <span> at the end)
  const getIndex = (el) => [...el.parentElement.children].filter(child => child.tagName === 'LI').indexOf(el);

  // 1. Toggle dropdown Open/Close
  if (toggle) {
    toggle.addEventListener('click', function(e) {
      e.stopPropagation(); // Prevents the 'click outside' listener from firing immediately
      container.classList.toggle('is-open');
    });
  }

  // 2. Handle clicking a tab item
  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      const index = getIndex(this);

      // A. Update the text inside the <span> without deleting the <svg>
      const label = toggle.querySelector('span');
      if (label) {
        label.textContent = this.textContent.trim();
      }
      
      // B. Update Active Classes on Tabs
      tabs.forEach(t => t.classList.remove('active-tab'));
      this.classList.add('active-tab');

      // C. Switch Content based on Index (Desktop-parity logic)
      if (contents.length > 0) {
        contents.forEach((content, i) => {
          content.style.display = (i === index) ? 'block' : 'none';
        });
      }
      
      // D. Close the dropdown menu
      container.classList.remove('is-open');
    });
  });

  // 3. Close the dropdown if the user clicks anywhere else on the page
  document.addEventListener('click', function(e) {
    if (container && !container.contains(e.target)) {
      container.classList.remove('is-open');
    }
  });
});